function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M43.33,19.8c-6.73-6.73-17.65-6.73-24.38,0-6.73,6.73-6.73,17.65,0,24.38,6.73,6.73,17.65,6.73,24.38,0,1.35-1.35,3.53-1.35,4.88,0s1.35,3.53,0,4.88c-9.43,9.43-24.71,9.43-34.14,0s-9.43-24.71,0-34.14,24.71-9.43,34.14,0l1.9,1.9v-5.52c0-1.91,1.54-3.45,3.45-3.45s3.45,1.54,3.45,3.45v13.79c0,1.91-1.54,3.45-3.45,3.45h-13.79c-1.91,0-3.45-1.54-3.45-3.45s1.54-3.45,3.45-3.45h5.42l-1.85-1.85Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/refreshIc.27ec125c.svg";
export { SvgComponent as ReactComponent };